import {registerComponent, registerRoute} from 'bloom';
import LP from 'modules/app/helpers/lp';
import LoginContainer from './containers/loginContainer';
import Bluebird from 'bluebird';

registerComponent('login', 'Login', LoginContainer, 'front');